import { Copy, TriangleAlert } from 'lucide-react';
import { useTranslation } from 'react-i18next';

import { Alert, AlertDescription, AlertTitle } from '@nucleus-commerce/ui/components/alert';
import { Button } from '@nucleus-commerce/ui/components/button';
import { DialogFooter } from '@nucleus-commerce/ui/components/dialog';
import { toast } from '@nucleus-commerce/ui/components/sonner';

/** The signing secret, shown once after create or rotate, with the header receivers check. */
export function SecretPanel({ secret, onDone }: { secret: string; onDone: () => void }) {
  const { t } = useTranslation('webhooks');
  const copy = async () => {
    try {
      await navigator.clipboard.writeText(secret);
      toast.success(t('secret.copied'));
    } catch {
      toast.error(t('secret.copyFailed'));
    }
  };
  return (
    <div className="flex flex-col gap-4">
      <div className="flex items-center gap-2">
        <code
          className="bg-muted flex-1 overflow-x-auto rounded-md px-3 py-2 font-mono text-sm select-all"
          data-testid="webhook-secret"
        >
          {secret}
        </code>
        <Button type="button" variant="outline" onClick={() => void copy()}>
          <Copy aria-hidden />
          {t('secret.copy')}
        </Button>
      </div>
      <p className="text-muted-foreground text-sm">{t('secret.howToVerify')}</p>
      <Alert>
        <TriangleAlert aria-hidden />
        <AlertTitle>{t('secret.warningTitle')}</AlertTitle>
        <AlertDescription>{t('secret.warning')}</AlertDescription>
      </Alert>
      <DialogFooter>
        <Button type="button" onClick={onDone}>
          {t('secret.done')}
        </Button>
      </DialogFooter>
    </div>
  );
}
